import { Box, Checkbox, Dialog, DialogContent, FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, Stack } from "@mui/material";
import { farmers, region } from "../../config/images";
import "./Region.css";
import { useState, useEffect } from "react";
import { deleteLocalGovernmentList, getStateDetails, updateLocalGovernmentList } from "../../config/services";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import translations from "../../config/language";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const LocalGovernment = ({ localGovernmentData, regionData, stateData, setLocalGovUpdated,
  localGovCurrentPage,
  setLocalGovCurrentPage,
  localGovCount,
  perPage,
  selectedlocalgovTable,
  setSelectedLocalgovTable
}) => {
  const [editLocalGovernment, setEditLocalGovernment] = useState(false);
  const [deleteLocalPopup, setDeleteLocalPopup] = useState(false);
  const [localGovernmentId, setLocalGovernmentId] = useState();
  const [regionName, setRegionName] = useState();
  const [stateName, setStateName] = useState();
  const [localGovernmentName, setLocalGovernmentName] = useState();
  const [loading, setLoading] = useState(false);
  const [stateBasedOnRegion, setStateBasedOnRegion] = useState([]);
  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Region & Locality" && module.is_editor === true
  ) ? true : false;

  const handleOpenEditDialog = (e) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setRegionName(e.region); // get the id of the region to show in the update form 
    setStateName(e.state); // get the id of the state to show in the update form 
    setLocalGovernmentName(e.local_government_name)
    setLocalGovernmentId(e.id);
    setEditLocalGovernment(true);
  };
  const handleEditLocalGovernment = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    try {
      setLoading(true);
      const params = {
        region: regionName,
        state: stateName,
        local_government_name: localGovernmentName
      }
      const resp = await updateLocalGovernmentList(localGovernmentId, params);

      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setEditLocalGovernment(false);
        setLocalGovUpdated(true) // ✅ Trigger local gov refresh
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };
  const handleOpenDeleteDialog = async (id) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setDeleteLocalPopup(true)
    setLocalGovernmentId(id);
  };
  const handleDeleteLocalGovernment = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    try {
      setLoading(true);
      const resp = await deleteLocalGovernmentList(localGovernmentId);
      if (resp.data) {
        notifySuccess(resp.data.message);
        setDeleteLocalPopup(false);
        setLocalGovUpdated(true) //  ✅ Trigger local gov refresh
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    } catch (error) {
      console.log("error");
      notifyError(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };
  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));
  const handlePageChange = (event, value) => {
    setLocalGovCurrentPage(value);
  };
  const getStateBasedOnRegion = async (regionId) => {
    try {
      const resp = await getStateDetails(regionId);
      if (resp.data.results.success == true) {
        setStateBasedOnRegion(resp.data.results.payload)
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
    }
  };
  useEffect(() => {
    if (regionName) {
      getStateBasedOnRegion(regionName)
    }
  }, [regionName])

  const language = process.env.REACT_APP_LANGUAGE

  const handleRowSelect = (id) => {
    setSelectedLocalgovTable((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };
  const handleSelectAll = () => {
    if (selectedlocalgovTable.length === localGovernmentData.length) {
      setSelectedLocalgovTable([]);
    } else {
      setSelectedLocalgovTable(localGovernmentData.map((e) => e.id));
    }
  };
  return (
    <>
      <Box className="table-container">
        <Table className="region-table" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "50px" }}>
                <Checkbox
                  sx={{
                    color: "rgba(225, 230, 244, 1)",
                    borderRadius: "4px",
                    "&.Mui-checked": {
                      color: "rgba(199, 206, 227,1)",
                    },
                  }}
                  checked={selectedlocalgovTable.length === localGovernmentData.length}
                  onChange={handleSelectAll}
                />
              </TableCell>
              <TableCell style={{ width: "100px" }}>{translations[language].srNo}</TableCell>
              <TableCell style={{ width: "200px" }}>{translations[language].regionName}</TableCell>
              <TableCell style={{ width: "200px" }}>{translations[language].stateName}</TableCell>
              <TableCell>{translations[language].localGovernmentName}</TableCell>
              <TableCell style={{ width: "100px" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {localGovernmentData?.length > 0 ? localGovernmentData.map((e, i) => {
              return (
                <TableRow>
                  <TableCell>
                    <Checkbox
                      sx={{
                        color: "rgba(225, 230, 244, 1)",
                        borderRadius: "4px",
                        "&.Mui-checked": {
                          color: "rgba(199, 206, 227,1)",
                        },
                      }}
                      checked={selectedlocalgovTable.includes(e.id)}
                      onChange={() => handleRowSelect(e.id)}
                    />
                  </TableCell>
                  {/* <TableCell>{i + 1}</TableCell> */}
                  <TableCell style={{ textAlign: "center" }}>{i + 1 + (localGovCurrentPage - 1) * perPage}</TableCell>
                  <TableCell>{e.region_name}</TableCell>
                  <TableCell>{e.state_name}</TableCell>
                  <TableCell>{e.local_government_name}</TableCell>
                  <TableCell>
                    <div className="d-flex gap-3">
                      <img
                        src={region.editIcon}
                        alt=""
                        style={{ cursor: "pointer", height: "23px" }}
                        onClick={() => handleOpenEditDialog(e)}
                      />
                      <img
                        src={region.deleteIcon}
                        alt=""
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenDeleteDialog(e.id)}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              );
            }) : <TableRow>
              <TableCell colSpan={6} style={{ textAlign: "center" }}>
                <img src={farmers.noData} alt="No Data" />
              </TableCell>
            </TableRow>}
          </TableBody>
        </Table>
      </Box>
      <Box display="flex" justifyContent="end" alignItems="center" className="pagination">
        <Stack spacing={2}>
          <CustomPagination
            count={Math.ceil(localGovCount / perPage)}
            page={localGovCurrentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Stack>
      </Box>
      <Dialog
        open={editLocalGovernment}
        maxWidth="xs"
        fullWidth
        disableScrollLock
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
      >
        <div className="assign-div">
          {" "}
          <div className="d-flex justify-content-around align-items-center">
            <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
              {translations[language].editLocalGovernment}
            </h5>
          </div>
        </div>
        <DialogContent>
          <form noValidate autoComplete="off">
            <FormControl fullWidth className="mb-3">
              <InputLabel>{translations[language].selectRegion}</InputLabel>
              <Select
                label={translations[language].srNo}
                name="region"
                value={regionName}
                onChange={(e) => setRegionName(e.target.value)}
              >
                {regionData.map((item, index) => (
                  <MenuItem value={item.id}>{item.region_name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth className="mb-3">
              <InputLabel>{translations[language].selectState}</InputLabel>
              <Select
                label={translations[language].selectState}
                name="region"
                value={stateName}
                onChange={(e) => setStateName(e.target.value)}
              >
                {stateBasedOnRegion.map((item, index) => (
                  <MenuItem value={item.id}>{item.state_name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              label={translations[language].enterLocalGovernment}
              name="taskTitle"
              value={localGovernmentName}
              onChange={(e) => {
                const inputValue = e.target.value;
                // Allow only letters and spaces, limit to 50 characters
                if (/^[A-Za-z\s]*$/.test(inputValue) && inputValue.length <= 50) {
                  setLocalGovernmentName(inputValue);
                }
              }}
              inputProps={{ maxLength: 50 }}
              className="mb-3"
            />

            <div className="d-flex gap-3 mt-2">
              <button
                className="cancel-button"
                onClick={(e) => {
                  e.preventDefault();
                  setEditLocalGovernment(false);
                }}
                style={{ fontSize: "14px" }}
              >
                {translations[language].cancel}
              </button>
              <button
                className="assign-task-button"
                onClick={(e) => handleEditLocalGovernment(e)}
                style={{ fontSize: "14px" }}
              >
                {translations[language].updateLocalGovernment}
              </button>
            </div>
          </form>
        </DialogContent>
      </Dialog>


      <Dialog
        open={deleteLocalPopup}
        // onClose={() => setDeleteLocalPopup(false)}
        maxWidth="xs"
        fullWidth
        disableScrollLock
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
      >
        <DialogContent className="p-5" style={{ textAlign: "center" }}>
          <Box>
            <img src={region.correct} alt="" />
          </Box>
          <Typography variant="h5" className="pt-4 mb-2">
            <b>{translations[language].deleteLocalGovernment}</b>
          </Typography>
          <Typography variant="p" className="pt-4" style={{ fontSize: "16px" }}>
            {translations[language].deleteLocalGovernmentConfirmation}
          </Typography>
          <div className="d-flex gap-3 pt-4">
            <button
              className="assign-task-button"
              onClick={(e) => handleDeleteLocalGovernment(e)}
              disabled={loading}
            >
              {loading ? <span className="spinner"></span> : translations[language].yes}
            </button>
            <button
              className="assign-task-button"
              onClick={(e) => { e.preventDefault(); setDeleteLocalPopup(false) }}
            >
              {translations[language].no}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LocalGovernment;